import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WhyDronesSection } from './components/WhyDronesSection';
import { VideoShowcase } from './components/VideoShowcase';
import { ServicesGrid } from './components/ServicesGrid';
import { HowItWorks } from './components/HowItWorks';
import { AboutBanner } from './components/AboutBanner';
import { MembershipTeaser } from './components/MembershipTeaser';
import { ServiceAreas } from './components/ServiceAreas';
import { FAQSection } from './components/FAQSection';
import { TrustedPartners } from './components/TrustedPartners';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-white font-heading scroll-smooth" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WhyDronesSection data-id="element-4" />
        <VideoShowcase data-id="element-5" />
        <ServicesGrid data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <AboutBanner data-id="element-8" />
        <MembershipTeaser data-id="element-9" />
        <ServiceAreas data-id="element-10" />
        <FAQSection data-id="element-11" />
        <TrustedPartners data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}